export const ACTIVE_FILTERS_BAR_LABEL_TEXT = "Active filters:";
export const ACTIVE_FILTERS_BAR_CLEAR_BUTTON_TEXT = "Clear all";

export const ACTIVE_FILTERS_BAR_TAG_TEST_ID = "active-filters-bar-tag";
export const ACTIVE_FILTERS_BAR_REMOVE_BUTTON_TEST_ID =
  "active-filters-bar-tag-remove-button";
export const ACTIVE_FILTERS_BAR_LABEL_TEST_ID = "active-filters-bar-label";
export const ACTIVE_FILTERS_BAR_CLEAR_BUTTON_TEST_ID = "clear-active-filters";
